angular.module('washCancelRequest', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/wash-cancel-request/wash-cancel-request.module.js